var _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaceholderPrinters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 208,
    viewBox: "0 0 283 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2411_55203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.748 149.025V100.372L236.507 74.453C237.844 73.4354 239.189 72.4178 240.526 71.4076C241.856 70.3973 242.329 68.6093 241.66 67.0829C241.457 66.596 241.246 66.1163 241.035 65.6293C240.773 65.0188 240.962 64.3065 241.486 63.8994L260.47 49.5301C260.499 49.5083 260.521 49.4937 260.55 49.4647C260.201 48.6579 259.845 47.8511 259.496 47.0443C257.897 43.3521 256.298 39.6598 254.699 35.9675C253.907 34.1359 251.778 33.2855 249.939 34.085C240.061 38.366 230.184 42.6398 220.299 46.9281C220.037 47.0443 219.79 47.1824 219.557 47.3569L208.059 56.0643L207.892 56.1878L207.848 56.2242C207.695 56.355 207.543 56.5003 207.405 56.6603C207.165 56.7693 206.947 56.9074 206.736 57.06L204.01 59.1242L175.504 80.7109C175.468 80.7327 175.439 80.7545 175.403 80.7836L175.374 80.8127C175.294 80.8708 175.214 80.9363 175.141 81.0089C175.032 81.0743 174.923 81.147 174.821 81.2197L174.814 81.227L163.272 89.9707L163.236 89.9925C161.934 90.981 161.418 92.7544 162.094 94.3171C163.693 98.0167 165.3 101.702 166.899 105.401C167.248 106.208 167.596 107.015 167.953 107.829V156.483L214.419 191.661L226.004 182.895L227.552 180.541L257.614 157.791H259.162L270.748 149.025Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2411_55203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.732 154.731C137.732 137.032 137.732 119.334 137.732 101.636C137.732 82.9854 137.732 64.3351 137.732 45.6847C137.732 44.4709 137.449 43.3007 136.918 42.2395C136.395 41.1856 135.632 40.248 134.665 39.5212C120.201 28.5752 105.745 17.6292 91.281 6.67588C90.0963 5.77462 88.4537 5.78188 87.2617 6.67588L43.4122 39.95C42.3511 40.4806 41.5661 41.5563 41.5661 42.93C41.5661 46.2734 41.5661 49.6095 41.5661 52.9529C31.6812 60.432 21.7964 67.911 11.9116 75.3974C10.7123 76.3059 10 77.7305 10 79.2423C10 93.0374 10 106.84 10 120.642C10 121.384 10.3489 122.081 10.9376 122.525L12.4712 123.68C12.4785 123.695 12.493 123.702 12.5076 123.71C13.2925 124.306 14.4409 124.4 15.3494 123.71C24.0932 117.095 32.8224 110.481 41.5661 103.867C41.5661 119.908 41.5661 135.942 41.5661 151.983C41.5661 154.403 42.6927 156.686 44.626 158.147C59.0899 169.093 73.5464 180.039 88.003 190.985C89.2968 191.959 90.9176 191.82 92.0296 190.985C92.0442 190.97 92.0587 190.956 92.0732 190.948L135.879 157.71L136.875 156.962C137.478 156.293 137.732 155.625 137.732 154.731Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2411_55203)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M270.75 100.371V149.017L259.164 157.783V109.136L270.75 100.371Z",
    fill: "url(#paint0_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M270.751 100.371L259.172 109.137C259.172 109.137 258.831 109.137 258.395 109.137C257.966 109.137 257.617 109.137 257.617 109.137L227.563 131.894L226.015 134.242L214.436 143.014L167.963 107.829L182.485 101.534L174.17 107.829L214.429 138.312L264.544 100.371L233.406 76.8005C234.438 76.0155 235.478 75.2305 236.51 74.4528L270.751 100.371Z",
    fill: "url(#paint1_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.534 100.372L214.419 138.312L174.16 107.829L182.475 101.535L196.99 95.2475L185.746 103.759L190.892 107.654L219.798 129.539L247.817 108.33L252.963 104.435L220.459 79.8315L223.693 77.3821C224.442 76.8152 225.525 77.0986 225.896 77.9563C226.019 78.247 226.15 78.5377 226.274 78.8285C226.833 80.1149 228.454 80.5438 229.573 79.6934C230.206 79.2137 230.845 78.7267 231.485 78.247C232.125 77.76 232.764 77.2731 233.411 76.7934L264.534 100.372Z",
    fill: "url(#paint2_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M259.498 47.0433C259.846 47.85 260.195 48.6568 260.544 49.4636C260.522 49.4854 260.493 49.5072 260.472 49.529L241.487 63.8984C240.956 64.2981 240.767 65.0177 241.036 65.6282C241.247 66.1079 241.45 66.5949 241.661 67.0746C242.323 68.6082 241.857 70.3889 240.527 71.3992C239.19 72.4168 237.845 73.4271 236.508 74.4446C235.476 75.2296 234.437 76.0146 233.404 76.7923C232.765 77.2793 232.125 77.7662 231.478 78.2459C230.359 79.0963 228.731 78.6675 228.179 77.381C228.055 77.0903 227.924 76.7996 227.801 76.5088C227.43 75.6512 226.347 75.3604 225.598 75.9274L223.687 77.381L220.452 79.8304L205.305 91.2997L204.23 92.1138C203.881 91.307 203.532 90.493 203.176 89.6862L214.754 80.9207L215.372 80.4555L246.676 56.7537L247.912 55.8161L259.498 47.0433Z",
    fill: "url(#paint3_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M254.7 35.9602C256.299 39.6525 257.905 43.3448 259.504 47.037L247.926 55.8026L243.121 44.7257C242.329 42.8941 240.199 42.051 238.368 42.8432C228.49 47.1243 218.605 51.4053 208.728 55.6863C208.488 55.7953 208.27 55.9189 208.066 56.057L219.565 47.3496C219.797 47.1751 220.044 47.0298 220.313 46.9135C230.191 42.6325 240.076 38.3515 249.953 34.0705C251.778 33.2855 253.907 34.1286 254.7 35.9602Z",
    fill: "url(#paint4_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.163 109.137V157.791H257.615V109.137C257.615 109.137 257.964 109.137 258.393 109.137C258.822 109.137 259.163 109.137 259.163 109.137Z",
    fill: "url(#paint5_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M257.614 109.137V157.783L227.553 180.54V131.894L257.614 109.137Z",
    fill: "url(#paint6_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M252.956 104.435L247.81 108.33V104.435L218.904 82.5498L190.885 103.759V107.654L185.746 103.759L196.99 95.2475L204.229 92.1076L205.305 91.2935L220.452 79.8315L252.956 104.435Z",
    fill: "url(#paint7_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.115 44.7251L247.919 55.802L246.683 56.7396L241.879 45.6627C241.087 43.8311 238.957 42.988 237.118 43.7803C227.241 48.0613 217.363 52.3423 207.478 56.6233C207.449 56.6306 207.42 56.6451 207.398 56.6596C207.537 56.4925 207.682 56.3544 207.842 56.2235L207.885 56.1872L208.053 56.0636C208.256 55.9183 208.474 55.7947 208.714 55.693C218.592 51.4119 228.476 47.1309 238.354 42.8499C240.193 42.0504 242.322 42.8935 243.115 44.7251Z",
    fill: "url(#paint8_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M247.811 104.434V108.33L219.799 129.539V125.643L247.811 104.434Z",
    fill: "url(#paint9_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.81 104.434L219.798 125.643L190.885 103.758L218.904 82.5496L247.81 104.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M241.879 45.6629L246.684 56.7398H245.688L241.044 46.0191C240.448 44.6527 238.863 44.0203 237.489 44.6163L204.012 59.1165L206.737 57.0523C206.948 56.8924 207.166 56.7616 207.406 56.6526C207.428 56.6453 207.457 56.6308 207.486 56.6162C217.364 52.3352 227.241 48.0542 237.126 43.7732C238.958 42.9882 241.087 43.8313 241.879 45.6629Z",
    fill: "url(#paint10_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M246.684 56.747L215.38 80.4415L215.133 79.8746L245.689 56.747H246.684Z",
    fill: "url(#paint11_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M241.043 46.0261L245.688 56.7468L215.132 79.8817L210.575 69.3718C209.783 67.5402 207.653 66.697 205.814 67.4893C195.937 71.7703 186.059 76.0513 176.174 80.3323C175.891 80.4486 175.636 80.6012 175.396 80.7902L204.004 59.1308L237.482 44.6306C238.856 44.0273 240.447 44.6597 241.043 46.0261Z",
    fill: "url(#paint12_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M231.477 78.2539C230.838 78.7336 230.205 79.2206 229.566 79.7003C228.439 80.5507 226.818 80.1219 226.266 78.8354C226.142 78.5447 226.011 78.2539 225.888 77.9632C225.517 77.1056 224.434 76.8148 223.686 77.389L225.597 75.9426C226.346 75.3757 227.429 75.6592 227.799 76.5241C227.923 76.8148 228.054 77.1056 228.177 77.3963C228.73 78.6755 230.358 79.1043 231.477 78.2539Z",
    fill: "url(#paint13_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.554 131.894V180.54L226.006 182.888V134.241L227.554 131.894Z",
    fill: "url(#paint14_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M226.006 134.241V182.888L214.42 191.653V143.007L226.006 134.241Z",
    fill: "url(#paint15_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M219.798 125.643V129.539L190.885 107.654V103.758L219.798 125.643Z",
    fill: "url(#paint16_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.132 79.8744L215.379 80.4414L214.761 80.9065L209.957 69.8297C209.165 67.9981 207.035 67.155 205.196 67.9472C195.319 72.2282 185.434 76.502 175.556 80.7902C175.411 80.8556 175.273 80.9283 175.135 81.0083C175.207 80.9356 175.287 80.8702 175.367 80.8048L175.404 80.7757C175.636 80.594 175.898 80.4414 176.181 80.3178C186.059 76.0368 195.937 71.7558 205.821 67.4748C207.653 66.6825 209.783 67.5257 210.582 69.3573L215.132 79.8744Z",
    fill: "url(#paint17_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M209.958 69.8299L214.762 80.9067L203.184 89.6722C201.585 85.98 199.979 82.2877 198.38 78.5954C197.587 76.7638 195.458 75.9207 193.626 76.7129C183.749 80.9939 173.864 85.2749 163.986 89.556C163.732 89.665 163.492 89.8031 163.281 89.963L174.823 81.2265L174.831 81.2193C174.932 81.1466 175.034 81.0739 175.143 81.0085C175.281 80.9285 175.419 80.8558 175.565 80.7904C185.442 76.5094 195.32 72.2284 205.205 67.9474C207.036 67.1552 209.166 67.9983 209.958 69.8299Z",
    fill: "url(#paint18_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M214.419 143.007V191.653L167.953 156.475V107.828L214.419 143.007Z",
    fill: "url(#paint19_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M203.176 89.6794C203.525 90.4862 203.874 91.3003 204.23 92.107L196.991 95.2469L182.476 101.534L167.954 107.828C167.605 107.022 167.257 106.207 166.9 105.401L203.176 89.6794Z",
    fill: "url(#paint20_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M198.37 78.5957C199.969 82.288 201.575 85.9876 203.174 89.6726L166.898 105.387C165.299 101.694 163.693 98.002 162.094 94.3097C161.418 92.7471 161.927 90.9736 163.235 89.9851L163.271 89.956C163.489 89.7961 163.722 89.658 163.976 89.549C173.854 85.268 183.739 80.987 193.616 76.706C195.448 75.9283 197.577 76.7641 198.37 78.5957Z",
    fill: "url(#paint21_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M137.736 101.629C137.736 119.327 137.736 137.025 137.736 154.724C137.736 155.625 137.482 156.286 136.878 156.955L135.89 157.711L92.084 190.941C92.8399 190.353 93.3559 189.43 93.3559 188.325C93.3559 170.627 93.3559 152.928 93.3559 135.23C93.3559 116.58 93.3559 97.9293 93.3559 79.279C93.3559 78.0652 93.0725 76.895 92.5492 75.8411L133.549 44.8056L136.936 42.2472C137.46 43.3011 137.743 44.4785 137.743 45.6851C137.736 64.3281 137.736 82.9858 137.736 101.629Z",
    fill: "url(#paint22_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M133.535 44.798L92.5344 75.8335C92.0111 74.7796 91.2407 73.842 90.2812 73.1079C75.8174 62.1619 61.3536 51.2159 46.897 40.2699C45.7995 39.4413 44.4694 39.4122 43.4082 39.9428L87.2577 6.67595C88.4496 5.77468 90.0923 5.77468 91.277 6.67595C105.741 17.622 120.197 28.568 134.661 39.514C135.628 40.2408 136.391 41.1784 136.914 42.2396L133.535 44.798Z",
    fill: "url(#paint23_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M93.3478 135.229C93.3478 152.928 93.3478 170.626 93.3478 188.324C93.3478 189.436 92.8318 190.352 92.0759 190.941C92.0613 190.955 92.0468 190.97 92.025 190.977C90.9129 191.813 89.2921 191.951 87.9984 190.977C73.5418 180.031 59.0779 169.085 44.6214 158.139C42.688 156.678 41.5541 154.396 41.5541 151.975C41.5541 135.934 41.5541 119.901 41.5541 103.86C43.3349 102.508 45.1229 101.156 46.9036 99.8111C48.1028 98.9026 48.8079 97.4926 48.8151 95.988C48.8224 97.4926 49.5274 98.9026 50.7267 99.8111C61.2439 107.777 71.7683 115.736 82.2855 123.702C83.8409 124.879 86.065 123.767 86.065 121.819C86.065 108.017 86.065 94.2218 86.065 80.4194C86.065 78.9076 85.36 77.483 84.1534 76.5745C73.7598 68.703 63.3589 60.8314 52.9653 52.9672C51.2645 51.6734 48.8224 52.8872 48.8079 55.0168C48.8006 54.1156 48.3572 53.3742 47.7176 52.9236C47.7176 52.9163 47.7104 52.9163 47.7031 52.909L46.2131 51.7824C45.2828 51.0774 44.0035 51.0774 43.0805 51.7824C42.5644 52.1749 42.0557 52.5601 41.5469 52.9454C41.5469 49.602 41.5469 46.2658 41.5469 42.9224C41.5469 41.5487 42.3318 40.473 43.393 39.9424C44.4542 39.4191 45.7915 39.4409 46.8818 40.2695C61.3384 51.2155 75.8022 62.1615 90.2661 73.1075C91.2327 73.8344 91.9959 74.772 92.5192 75.8331C93.0425 76.887 93.326 78.0645 93.326 79.271C93.3478 97.9287 93.3478 116.579 93.3478 135.229ZM86.0868 177.741C86.0868 163.939 86.0868 150.144 86.0868 136.341C86.0868 134.83 85.3818 133.405 84.1753 132.497C73.7816 124.625 63.3807 116.761 52.9871 108.889C51.2791 107.595 48.8297 108.809 48.8297 110.953C48.8297 124.596 48.8297 138.238 48.8297 151.881C48.8297 153.393 49.5347 154.817 50.7412 155.733C61.2584 163.699 71.7829 171.658 82.3 179.624C83.8554 180.794 86.0868 179.689 86.0868 177.741Z",
    fill: "url(#paint24_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M86.0852 136.335C86.0852 150.137 86.0852 163.932 86.0852 177.735C86.0852 179.683 83.8539 180.795 82.3058 179.617C71.7813 171.658 61.2569 163.692 50.7397 155.726C49.5404 154.818 48.8281 153.386 48.8281 151.874C48.8281 138.232 48.8281 124.589 48.8281 110.947C48.8281 108.802 51.2775 107.589 52.9856 108.882C63.3792 116.754 73.7728 124.618 84.1737 132.49C85.373 133.406 86.0852 134.823 86.0852 136.335ZM85.293 177.742C85.293 163.94 85.293 150.144 85.293 136.342C85.293 135.077 84.697 133.893 83.694 133.129C80.605 130.789 77.5087 128.449 74.4197 126.108C70.5966 123.215 66.7807 120.33 62.9649 117.437C62.7469 117.27 62.5215 117.103 62.3108 116.943C59.04 114.472 55.7766 111.993 52.5131 109.522C51.3284 108.628 49.6204 109.471 49.6204 110.954C49.6204 124.596 49.6204 138.239 49.6204 151.881C49.6204 153.146 50.2164 154.331 51.2194 155.094C61.7366 163.06 72.2537 171.026 82.7782 178.985C83.8103 179.77 85.293 179.036 85.293 177.742Z",
    fill: "url(#paint25_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.3841 102.334C64.513 109.253 73.6493 116.158 82.7782 123.078C83.7013 123.775 84.9732 123.267 85.2421 122.227C85.2785 122.104 85.293 121.965 85.293 121.827C85.293 121.319 85.293 120.81 85.293 120.301C85.293 118.949 85.293 117.597 85.293 116.245C85.293 104.304 85.293 92.3691 85.293 80.4201C85.293 79.1554 84.697 77.9707 83.694 77.2075C83.5632 77.1058 83.4324 77.004 83.3015 76.9095C82.3276 76.1682 81.3464 75.4341 80.3724 74.6927C71.0836 67.6643 61.7947 60.6359 52.5131 53.6002C51.3284 52.6989 49.6204 53.5493 49.6204 55.032C49.6204 56.2313 49.6204 57.4306 49.6204 58.6371C49.6204 59.3639 49.6204 60.0835 49.6204 60.803V60.8103C49.4096 60.963 49.1407 61.0574 48.8354 61.0574C48.8354 59.0514 48.8354 57.0381 48.8354 55.0248C48.8354 55.0175 48.8354 55.0102 48.8354 55.003C48.8499 52.8734 51.2921 51.6668 52.9928 52.9533C63.3865 60.8176 73.7801 68.6891 84.181 76.5606C85.3802 77.4692 86.0925 78.8938 86.0925 80.4056C86.0925 94.208 86.0925 108.003 86.0925 121.806C86.0925 123.753 83.8612 124.866 82.313 123.688C71.7813 115.744 61.2569 107.778 50.7397 99.8191C49.5404 98.9106 48.8354 97.5005 48.8281 95.996C48.8281 95.9887 48.8281 95.9814 48.8281 95.9669C48.8281 94.8476 48.8281 93.7356 48.8281 92.6235C49.1261 92.6235 49.3951 92.529 49.6204 92.3619C49.6204 93.5611 49.6204 94.7604 49.6204 95.9669C49.6204 97.2316 50.2164 98.4163 51.2194 99.1795C52.6076 100.233 53.9959 101.287 55.3841 102.334Z",
    fill: "url(#paint26_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2898 136.335C85.2898 150.137 85.2898 163.932 85.2898 177.735C85.2898 179.028 83.8071 179.763 82.775 178.985C72.2578 171.019 61.7334 163.06 51.2162 155.094C50.2059 154.331 49.6172 153.139 49.6172 151.881C49.6172 138.239 49.6172 124.596 49.6172 110.954C49.6172 109.471 51.318 108.621 52.51 109.522C55.7734 111.993 59.0441 114.472 62.3076 116.943L61.6534 117.437C58.4481 115.01 55.2356 112.582 52.0303 110.147C51.3688 109.646 50.4167 110.118 50.4167 110.954C50.4167 124.596 50.4167 138.239 50.4167 151.881C50.4167 152.899 50.8891 153.851 51.7032 154.462C56.8709 158.372 62.0386 162.29 67.2064 166.2L67.9114 165.618V166.738C73.0283 170.612 78.1451 174.486 83.2547 178.353C83.7635 178.738 84.4976 178.374 84.4976 177.735C84.4976 163.932 84.4976 150.137 84.4976 136.335C84.4976 135.317 84.0251 134.365 83.2111 133.754C80.0639 131.37 76.9095 128.986 73.7624 126.602L74.4165 126.108C77.5055 128.449 80.6018 130.789 83.6908 133.129C84.6938 133.885 85.2898 135.077 85.2898 136.335Z",
    fill: "url(#paint27_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M85.2887 120.301C85.2887 120.81 85.2887 121.319 85.2887 121.827C85.2887 121.965 85.2742 122.103 85.2378 122.227L55.3798 99.6227L52.7051 97.6021V95.6324L85.2887 120.301Z",
    fill: "url(#paint28_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M85.2887 116.245C85.2887 117.597 85.2887 118.949 85.2887 120.301L52.7051 95.6326L80.3681 74.6928C81.3421 75.4341 82.3233 76.1682 83.2972 76.9096L58.3162 95.8216L83.2972 114.734L85.2887 116.245Z",
    fill: "url(#paint29_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2928 80.4272C85.2928 92.369 85.2928 104.303 85.2928 116.252L83.3013 114.741L58.3203 95.8287L83.3013 76.9166C83.4322 77.0184 83.563 77.1201 83.6938 77.2146C84.6968 77.9705 85.2928 79.1625 85.2928 80.4272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.3789 99.6224L85.2369 122.227C84.9753 123.266 83.6961 123.768 82.773 123.077C73.6368 116.165 64.5078 109.253 55.3789 102.333V99.6224Z",
    fill: "url(#paint30_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M84.5002 136.334C84.5002 150.137 84.5002 163.932 84.5002 177.734C84.5002 178.374 83.7734 178.737 83.2574 178.352C78.1405 174.478 73.0237 170.611 67.9141 166.737V165.618V126.319L72.4422 129.742L72.464 129.757C72.9873 130.156 73.7723 129.793 73.7723 129.102V128.753V126.595C76.9194 128.979 80.0739 131.363 83.221 133.747C84.0205 134.365 84.5002 135.324 84.5002 136.334Z",
    fill: "url(#paint31_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M80.3692 74.6924L52.7062 95.6322V97.6019L55.3809 99.6225V102.334C53.9927 101.287 52.6044 100.233 51.2162 99.1864C50.2059 98.4233 49.6172 97.2313 49.6172 95.9738C49.6172 94.7746 49.6172 93.5753 49.6172 92.3688C49.9515 92.1289 50.1696 91.7292 50.1696 91.2858V87.957C50.1914 87.5427 50.0169 87.1138 49.6172 86.8231V78.2756C49.9515 78.0358 50.1696 77.636 50.1696 77.1926V73.8638C50.1914 73.4495 50.0169 73.0279 49.6172 72.7299V64.1897C49.9515 63.9499 50.1696 63.5501 50.1696 63.1067V59.7779C50.1914 59.3636 50.0169 58.942 49.6172 58.644C49.6172 57.4448 49.6172 56.2382 49.6172 55.039C49.6172 53.5562 51.318 52.7058 52.51 53.6071C61.7915 60.6355 71.0804 67.6639 80.3692 74.6924Z",
    fill: "url(#paint32_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9629 117.43C66.7787 120.322 70.5946 123.208 74.4177 126.101L73.7635 126.595V128.754L69.1773 125.279L68.4722 125.861V124.742L63.886 121.267C63.3118 120.831 62.9774 120.155 62.9774 119.436V117.43H62.9629Z",
    fill: "url(#paint33_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.4363 129.75L67.9082 126.326L68.4606 125.876L69.1656 125.294L73.7519 128.768V129.117C73.7519 129.8 72.9669 130.164 72.4436 129.771L72.4363 129.75Z",
    fill: "url(#paint34_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.4639 124.749V125.868L67.9115 126.326V165.619L67.1992 166.2V125.788L68.4639 124.749Z",
    fill: "url(#paint35_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4686 124.749L67.2039 125.781L62.5667 122.27C61.9925 121.834 61.6582 121.158 61.6582 120.439V117.43L62.3123 116.935C62.5304 117.095 62.7484 117.262 62.9665 117.43V119.443C62.9665 120.162 63.3081 120.838 63.875 121.274L68.4686 124.749Z",
    fill: "url(#paint36_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M67.1979 125.788V166.207C62.0302 162.296 56.8624 158.379 51.6947 154.469C50.8879 153.858 50.4082 152.899 50.4082 151.888C50.4082 138.246 50.4082 124.603 50.4082 110.961C50.4082 110.125 51.3603 109.66 52.0218 110.154C55.2271 112.582 58.4396 115.009 61.6449 117.444V120.453C61.6449 121.173 61.9793 121.849 62.5535 122.285L67.1979 125.788Z",
    fill: "url(#paint37_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.1696 59.7781C50.155 60.1852 49.9515 60.5776 49.6172 60.8175V60.8102C49.6172 60.0834 49.6172 59.3638 49.6172 58.6443C50.0169 58.935 50.1841 59.3638 50.1696 59.7781Z",
    fill: "url(#paint38_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.1696 73.8635C50.155 74.2705 49.9515 74.663 49.6172 74.9029V74.8956V72.7297C50.0169 73.0277 50.1841 73.4565 50.1696 73.8635Z",
    fill: "url(#paint39_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.1696 87.957C50.155 88.3641 49.9515 88.7565 49.6172 88.9964V88.9819V86.8159C50.0169 87.1139 50.1841 87.5427 50.1696 87.957Z",
    fill: "url(#paint40_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.1683 87.9565V91.2854C50.1683 91.7288 49.9503 92.1285 49.6159 92.3684C49.3906 92.5283 49.1217 92.63 48.8237 92.63C48.5257 92.63 48.2495 92.5355 48.0314 92.3684C47.6971 92.1212 47.4863 91.7288 47.4863 91.2854V87.9565C47.5009 88.3635 47.7044 88.756 48.0387 89.0031C48.2495 89.1558 48.5184 89.2503 48.8237 89.2503C49.1362 89.2503 49.3979 89.1558 49.6087 89.0031C49.9503 88.756 50.1538 88.3563 50.1683 87.9565Z",
    fill: "url(#paint41_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.1683 73.8639V77.1928C50.1683 77.6361 49.9503 78.0359 49.6159 78.2757C49.3906 78.4356 49.1217 78.5374 48.8237 78.5374C48.5257 78.5374 48.2495 78.4429 48.0314 78.2757C47.6971 78.0286 47.4863 77.6361 47.4863 77.1928V73.8639C47.5009 74.2709 47.7044 74.6634 48.0387 74.9033C48.2495 75.0559 48.5184 75.1504 48.8237 75.1504C49.1362 75.1504 49.3979 75.0559 49.6087 74.9033C49.9503 74.6634 50.1538 74.2709 50.1683 73.8639Z",
    fill: "url(#paint42_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.1683 59.7783V63.1071C50.1683 63.5505 49.9503 63.943 49.6159 64.1901C49.3906 64.35 49.1217 64.4518 48.8237 64.4518C48.5257 64.4518 48.2495 64.3573 48.0314 64.1901C47.6971 63.9502 47.4863 63.5505 47.4863 63.1071V59.7783C47.5009 60.1853 47.7044 60.5778 48.0387 60.8176C48.2495 60.9703 48.5184 61.0648 48.8237 61.0648C49.1362 61.0648 49.3979 60.9703 49.6087 60.8176C49.9503 60.5778 50.1538 60.178 50.1683 59.7783Z",
    fill: "url(#paint43_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.619 86.8154V88.9813V88.9958C49.4082 89.1485 49.1393 89.243 48.834 89.243V78.5295C49.132 78.5295 49.4009 78.435 49.6262 78.2679V86.8154H49.619Z",
    fill: "url(#paint44_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.619 72.73V74.8959V74.9032C49.4082 75.0558 49.1393 75.1503 48.834 75.1503V64.4441C49.132 64.4441 49.4009 64.3497 49.6262 64.1825V72.73H49.619Z",
    fill: "url(#paint45_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.7347 52.9237C48.3743 53.3743 48.8177 54.1157 48.825 55.0169C48.825 55.0242 48.825 55.0315 48.825 55.0387C48.825 57.0521 48.825 59.0581 48.825 61.0714C48.5124 61.0714 48.2508 60.9769 48.04 60.8243L48.0327 60.817C48.0327 60.0902 48.0327 59.3706 48.0327 58.6511C48.0327 57.4518 48.0327 56.2453 48.0327 55.046C48.0327 53.5633 46.3319 52.7129 45.1399 53.6142C34.7463 61.4857 24.3527 69.35 13.9591 77.2215C12.9488 77.9847 12.3601 79.1767 12.3601 80.4341C12.3601 86.0016 12.3601 91.569 12.3601 97.1365C12.9997 96.6568 13.6393 96.1699 14.2716 95.6901C14.4751 95.5375 14.7659 95.6829 14.7659 95.9373C14.7659 96.2643 14.7659 96.5914 14.7659 96.9258C14.7659 98.721 14.7659 100.516 14.7659 102.312C14.7659 102.522 14.7659 102.726 14.7659 102.929C14.7659 103.169 14.6859 103.329 14.4969 103.474C13.7846 104.012 13.0723 104.55 12.3601 105.088C12.3601 110.67 12.3601 116.252 12.3601 121.834C12.3601 123.128 13.8428 123.862 14.8676 123.084C25.3848 115.118 35.9092 107.159 46.4264 99.1935C47.4367 98.4303 48.0255 97.2383 48.0255 95.9809C48.0255 94.7816 48.0255 93.5823 48.0255 92.3758C48.2508 92.5357 48.5197 92.6375 48.8177 92.6375C48.8177 93.7568 48.8177 94.8688 48.8177 95.9809C48.8177 95.9881 48.8177 95.9954 48.8177 96.0099C48.8104 97.5145 48.1054 98.9245 46.9061 99.8331C45.1254 101.185 43.3374 102.537 41.5567 103.881C32.8202 110.496 24.0838 117.11 15.3473 123.724C14.4388 124.414 13.2904 124.32 12.4982 123.724C12.4836 123.717 12.4691 123.702 12.4618 123.695C11.924 123.28 11.5605 122.626 11.5605 121.841C11.5605 108.039 11.5605 94.2438 11.5605 80.4413C11.5605 78.9295 12.2656 77.5049 13.4721 76.5964C23.8657 68.7249 34.2593 60.8534 44.653 52.9891C45.6269 52.2477 46.848 52.3277 47.7129 52.9309C47.7275 52.9164 47.7347 52.9164 47.7347 52.9237Z",
    fill: "url(#paint46_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.8293 64.4442V75.1504C48.5168 75.1504 48.2552 75.0559 48.0444 74.9033L48.0371 74.896V72.7301V64.1898C48.2624 64.3497 48.5313 64.4442 48.8293 64.4442Z",
    fill: "url(#paint47_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.4784 59.7781C47.4566 59.3638 47.6238 58.9423 48.0236 58.6443C48.0236 59.3711 48.0236 60.0907 48.0236 60.8102L48.0308 60.8175C47.6965 60.5776 47.5002 60.1779 47.4784 59.7781Z",
    fill: "url(#paint48_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.4784 73.8635C47.4566 73.4492 47.6238 73.0277 48.0236 72.7297V74.8956L48.0308 74.9029C47.6965 74.663 47.5002 74.2705 47.4784 73.8635Z",
    fill: "url(#paint49_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.4784 87.9498C47.4566 87.5355 47.6238 87.1139 48.0236 86.8159V88.9819L48.0308 88.9964C47.6965 88.7493 47.5002 88.3568 47.4784 87.9498Z",
    fill: "url(#paint50_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.4691 67.119C39.4037 67.148 39.3456 67.1844 39.2874 67.228C32.9713 72.0105 26.6552 76.7858 20.3391 81.5683C19.7285 82.0335 19.3724 82.753 19.3724 83.5234C19.3724 91.7511 19.3724 99.9861 19.3724 108.214C19.3724 108.366 19.3724 108.519 19.3724 108.672C19.3724 109.457 20.2736 109.907 20.8987 109.428C27.2875 104.587 33.6836 99.7535 40.0724 94.9128C40.6829 94.4476 41.0463 93.7281 41.0463 92.9576C41.0463 92.2308 41.0463 91.4967 41.0463 90.7699C41.0463 84.3811 41.0463 77.985 41.0463 71.5962C41.0463 70.426 41.0463 69.2631 41.0463 68.0929C41.0391 67.2716 40.1669 66.7701 39.4691 67.119ZM48.0384 92.3617C48.0384 93.5609 48.0384 94.7602 48.0384 95.9667C48.0384 97.2314 47.4497 98.4161 46.4394 99.1793C35.9222 107.145 25.3978 115.111 14.8806 123.07C13.8485 123.848 12.373 123.121 12.373 121.82C12.373 116.238 12.373 110.656 12.373 105.074C13.0853 104.536 13.7976 103.998 14.5099 103.46C14.7062 103.308 14.7788 103.155 14.7788 102.915C14.7788 102.704 14.7788 102.501 14.7788 102.297C14.7788 100.502 14.7788 98.7068 14.7788 96.9116C14.7788 96.5845 14.7788 96.2574 14.7788 95.9231C14.7788 95.6687 14.4881 95.5233 14.2846 95.676C13.645 96.1557 13.0054 96.6427 12.373 97.1224C12.373 91.5549 12.373 85.9874 12.373 80.4199C12.373 79.1552 12.9618 77.9705 13.9721 77.2073C24.3657 69.3358 34.7593 61.4715 45.1529 53.6C46.3376 52.6987 48.0457 53.5491 48.0457 55.0319C48.0457 56.2311 48.0457 57.4304 48.0457 58.6369C47.6459 58.9349 47.4788 59.3565 47.5006 59.7708V63.0996C47.5006 63.543 47.7186 63.9355 48.0457 64.1826V72.7228C47.6459 73.0208 47.4788 73.4424 47.5006 73.8567V77.1855C47.5006 77.6289 47.7186 78.0214 48.0457 78.2685V86.8087C47.6459 87.0994 47.4788 87.5283 47.5006 87.9425V91.2714C47.486 91.7293 47.7041 92.1218 48.0384 92.3617Z",
    fill: "url(#paint51_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 51.7831L47.7223 52.9097C46.8574 52.3065 45.6363 52.2265 44.6623 52.9679C34.2687 60.8321 23.8751 68.7037 13.4815 76.5752C12.275 77.4837 11.5699 78.9083 11.5699 80.4201C11.5699 94.2225 11.5699 108.018 11.5699 121.82C11.5699 122.605 11.9334 123.252 12.4712 123.674L10.9376 122.511C10.3489 122.075 10 121.377 10 120.643C10 106.84 10 93.0378 10 79.2426C10 77.7309 10.705 76.3063 11.9116 75.3977C21.7964 67.9187 31.674 60.4324 41.5588 52.9533C42.0748 52.5609 42.5836 52.1756 43.0924 51.7904C44.0227 51.0854 45.302 51.0854 46.2323 51.7831Z",
    fill: "url(#paint52_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0412 90.7768C41.0412 91.5036 41.0412 92.2377 41.0412 92.9645C41.0412 93.735 40.6777 94.4545 40.0672 94.9197C33.6784 99.7603 27.2823 104.594 20.8935 109.434C20.2685 109.907 19.3672 109.463 19.3672 108.679C19.3672 108.526 19.3672 108.373 19.3672 108.221C25.7415 103.394 32.123 98.5611 38.4973 93.735C39.1078 93.2698 39.4639 92.5502 39.4639 91.7798C39.4639 91.053 39.4639 90.3189 39.4639 89.592V70.4184V67.1186C40.169 66.777 41.0339 67.2712 41.0339 68.0998C41.0339 69.27 41.0339 70.4402 41.0339 71.6031C41.0412 77.9919 41.0412 84.388 41.0412 90.7768Z",
    fill: "url(#paint53_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.4698 89.5851C39.4698 90.312 39.4698 91.0461 39.4698 91.7729C39.4698 92.536 39.1064 93.2629 38.5031 93.728C32.1216 98.5542 25.7473 103.388 19.373 108.214C19.373 99.986 19.373 91.7511 19.373 83.5234C19.373 82.7602 19.7365 82.0334 20.3397 81.5682C26.6558 76.7857 32.972 72.0105 39.2881 67.2279C39.3462 67.1843 39.4116 67.148 39.4698 67.1189V70.4187V89.5851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M247.81 104.434L219.798 125.643L190.885 103.758L218.904 82.5496L247.81 104.434Z",
    fill: "url(#paint54_linear_2411_55203)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.2928 80.4272C85.2928 92.369 85.2928 104.303 85.2928 116.252L83.3013 114.741L58.3203 95.8287L83.3013 76.9166C83.4322 77.0184 83.563 77.1201 83.6938 77.2146C84.6968 77.9705 85.2928 79.1625 85.2928 80.4272Z",
    fill: "url(#paint55_linear_2411_55203)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2411_55203",
    x: 153.797,
    y: 29.7842,
    width: 128.951,
    height: 177.877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2411_55203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2411_55203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2411_55203",
    x: 2,
    y: 2.00266,
    width: 147.732,
    height: 205.662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2411_55203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2411_55203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2411_55203",
    x: 0,
    y: 0,
    width: 280.75,
    height: 205.657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2411_55203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2411_55203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2411_55203",
    x1: 259.166,
    y1: 129.076,
    x2: 270.748,
    y2: 129.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2411_55203",
    x1: 167.954,
    y1: 108.728,
    x2: 270.749,
    y2: 108.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2411_55203",
    x1: 174.161,
    y1: 107.552,
    x2: 264.537,
    y2: 107.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2411_55203",
    x1: 203.176,
    y1: 69.574,
    x2: 260.549,
    y2: 69.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2411_55203",
    x1: 208.059,
    y1: 44.9207,
    x2: 259.499,
    y2: 44.9207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2411_55203",
    x1: 167.952,
    y1: 133.46,
    x2: 270.747,
    y2: 133.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2411_55203",
    x1: 227.556,
    y1: 144.837,
    x2: 257.613,
    y2: 144.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2411_55203",
    x1: 185.743,
    y1: 94.0785,
    x2: 252.955,
    y2: 94.0785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2411_55203",
    x1: 207.407,
    y1: 49.6455,
    x2: 247.918,
    y2: 49.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2411_55203",
    x1: 219.796,
    y1: 116.986,
    x2: 247.813,
    y2: 116.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2411_55203",
    x1: 204.014,
    y1: 51.304,
    x2: 246.681,
    y2: 51.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2411_55203",
    x1: 215.131,
    y1: 68.5937,
    x2: 246.682,
    y2: 68.5937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2411_55203",
    x1: 175.405,
    y1: 62.5881,
    x2: 245.687,
    y2: 62.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2411_55203",
    x1: 223.683,
    y1: 77.8912,
    x2: 231.475,
    y2: 77.8912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2411_55203",
    x1: 226.006,
    y1: 157.391,
    x2: 227.557,
    y2: 157.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2411_55203",
    x1: 214.423,
    y1: 162.948,
    x2: 226.005,
    y2: 162.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2411_55203",
    x1: 190.886,
    y1: 116.647,
    x2: 219.795,
    y2: 116.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2411_55203",
    x1: 175.139,
    y1: 74.0954,
    x2: 215.377,
    y2: 74.0954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2411_55203",
    x1: 163.274,
    y1: 78.809,
    x2: 214.759,
    y2: 78.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2411_55203",
    x1: 167.951,
    y1: 149.741,
    x2: 214.422,
    y2: 149.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2411_55203",
    x1: 166.9,
    y1: 98.7515,
    x2: 204.229,
    y2: 98.7515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2411_55203",
    x1: 161.797,
    y1: 90.908,
    x2: 203.174,
    y2: 90.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2411_55203",
    x1: 92.0803,
    y1: 116.591,
    x2: 137.734,
    y2: 116.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2411_55203",
    x1: 43.4056,
    y1: 40.9195,
    x2: 136.916,
    y2: 40.9195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2411_55203",
    x1: 41.5658,
    y1: 115.628,
    x2: 93.3486,
    y2: 115.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2411_55203",
    x1: 48.8288,
    y1: 144.228,
    x2: 86.0826,
    y2: 144.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2411_55203",
    x1: 48.8288,
    y1: 88.3154,
    x2: 86.0826,
    y2: 88.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ACC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#627091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2411_55203",
    x1: 49.6165,
    y1: 144.228,
    x2: 85.2884,
    y2: 144.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ACC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#627091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2411_55203",
    x1: 52.7054,
    y1: 108.93,
    x2: 85.2873,
    y2: 108.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2411_55203",
    x1: 52.7054,
    y1: 97.4972,
    x2: 85.2873,
    y2: 97.4972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2411_55203",
    x1: 55.3769,
    y1: 111.508,
    x2: 85.2354,
    y2: 111.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2411_55203",
    x1: 67.9112,
    y1: 152.418,
    x2: 84.4971,
    y2: 152.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2411_55203",
    x1: 49.6165,
    y1: 77.783,
    x2: 80.3678,
    y2: 77.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2411_55203",
    x1: 62.9635,
    y1: 123.098,
    x2: 74.4184,
    y2: 123.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ACC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#627091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2411_55203",
    x1: 67.9126,
    y1: 127.61,
    x2: 73.7643,
    y2: 127.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2411_55203",
    x1: 67.2006,
    y1: 145.477,
    x2: 68.4635,
    y2: 145.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2411_55203",
    x1: 61.6565,
    y1: 121.36,
    x2: 68.4681,
    y2: 121.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ACC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#627091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2411_55203",
    x1: 50.4093,
    y1: 138.071,
    x2: 67.1993,
    y2: 138.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2411_55203",
    x1: 49.6133,
    y1: 59.7298,
    x2: 50.1696,
    y2: 59.7298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2411_55203",
    x1: 49.6133,
    y1: 73.8182,
    x2: 50.1696,
    y2: 73.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2411_55203",
    x1: 49.6133,
    y1: 87.9076,
    x2: 50.1696,
    y2: 87.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2411_55203",
    x1: 47.4817,
    y1: 90.2861,
    x2: 50.1669,
    y2: 90.2861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2411_55203",
    x1: 47.4817,
    y1: 76.1993,
    x2: 50.1669,
    y2: 76.1993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2411_55203",
    x1: 47.4817,
    y1: 62.1121,
    x2: 50.1669,
    y2: 62.1121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2411_55203",
    x1: 48.8274,
    y1: 83.7597,
    x2: 49.6182,
    y2: 83.7597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2411_55203",
    x1: 48.8274,
    y1: 69.6729,
    x2: 49.6182,
    y2: 69.6729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2411_55203",
    x1: 11.5686,
    y1: 88.3146,
    x2: 48.8256,
    y2: 88.3146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2411_55203",
    x1: 48.0359,
    y1: 69.6713,
    x2: 48.83,
    y2: 69.6713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2411_55203",
    x1: 47.4797,
    y1: 59.7298,
    x2: 48.036,
    y2: 59.7298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2411_55203",
    x1: 47.4797,
    y1: 73.8182,
    x2: 48.036,
    y2: 73.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2411_55203",
    x1: 47.4797,
    y1: 87.9076,
    x2: 48.036,
    y2: 87.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2411_55203",
    x1: 12.3684,
    y1: 88.3142,
    x2: 48.0372,
    y2: 88.3142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2411_55203",
    x1: 10.0017,
    y1: 87.4694,
    x2: 47.7243,
    y2: 87.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2411_55203",
    x1: 19.3702,
    y1: 88.316,
    x2: 41.0395,
    y2: 88.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2411_55203",
    x1: 190.886,
    y1: 104.097,
    x2: 247.812,
    y2: 104.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2411_55203",
    x1: 58.3158,
    y1: 96.5785,
    x2: 85.2915,
    y2: 96.5785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderPrinters);
export default __webpack_public_path__ + "static/media/placeholder_printers.636c48c3259de7ad81ac6b13f61b3028.svg";
export { ForwardRef as ReactComponent };